import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ShopService } from '@app/services/shops/shop.service';
import { catchError, filter, first, map, of, timeout } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FullPlatformGuard {
  constructor(
    private shopService: ShopService,
    private router: Router,
  ) {}

  canActivate() {
    return this.shopService.shop$.pipe(
      filter((shop) => !!shop),
      first(),
      timeout(5000),
      map((shop) => {
        return shop.isCheckoutOnly ? this.router.parseUrl('/deliver/manage/verify') : true;
      }),
      catchError(() => {
        return of(this.router.parseUrl('/deliver/manage/verify'));
      }),
    );
  }
}
